// @noflow
import Icon from '~/core/icons';
import { iconContainerSize } from '../style-variables';
import styled from 'styled-components';

const triangleSize = '12px';

export const Container = styled.div`
    border: 1px solid ${p => p.theme.mediumGrey};
    border-radius: 0.5em;
    overflow: hidden;
    position: relative;
`;

export const Header = styled.div`
    align-items: center;
    display: flex;
    justify-content: flex-start;
    padding: 0.5em 1em;
`;

export const IconWrapper = styled.div`width: ${2.5 * iconContainerSize}em;`;

export const StyledIcon = styled(Icon)`
    align-items: center;
    background-color: ${p => p.theme.mainBrandColor};
    border-radius: 50%;
    color: ${p => p.theme.white};
    display: flex;
    font-size: 2.5em;
    height: ${iconContainerSize}em;
    justify-content: center;
    transition: background-color 0.3s ease-in;
    width: ${iconContainerSize}em;
`;

export const Summary = styled.div`
    display: flex;
    flex-direction: column;
    margin-left: 1em;
    width: calc(80% - 1em);
`;

export const Device = styled.span`
    font-size: 1.5em;
    margin-left: 0.25em;
`;

export const Description = styled.div`
    color: ${p => p.theme.mainBrandColor};
    font-size: 1.2em;
`;

export const Toggle = styled.div`
    display: flex;
    justify-content: flex-end;
    width: calc(40% - 1em);
`;

export const Seperator = styled.div`
    border-bottom: 1px solid ${p => p.theme.mediumGrey};

    &:before,
    &:after {
        content: '';
        display: block;
        width: 0;
        height: 0;
        left: calc(50% - ${triangleSize});
        border-left: ${triangleSize} solid transparent;
        border-right: ${triangleSize} solid transparent;
        border-top: ${triangleSize} solid ${p => p.theme.mediumGrey};
        position: absolute;
        z-index: 1;
    }

    &:after {
        border-top: ${triangleSize} solid
            ${p =>
                ({
                    [p.index % 2 === 0]: p.theme.lightGrey,
                    [p.index % 2 !== 0]: p.theme.paleGrey,
                    [p.index === 0]: p.theme.white
                }[true])};
        margin-top: -1px;
    }
`;

export const Option = styled.div`
    align-items: center;
    background-color: ${p => (p.index % 2 === 0 ? p.theme.paleGrey : p.theme.lightGrey)};
    display: flex;
    justify-content: space-between;
    padding: 1em;
`;



// WEBPACK FOOTER //
// ./src/components/widgets/recipes/then-notify/style.js